
export default {
  name: 'AppProgressCheckIcon',
  props: {
    progress: { type: Number, required: true, validator: v => 0 <= v && v <= 1 }
  },
  data() {
    return { status: this.progress === 1 ? 'full' : 'not-full' };
  },
  computed: {
    progressCircleStyle() {
      const radius = 7.5;
      const circumference = 2 * Math.PI * radius;
      const offset = circumference * (1 - this.progress);

      return {
        '--stroke-dasharray': circumference,
        '--stroke-dashoffset': offset
      };
    }
  },
  watch: {
    progress() {
      if (this.flipTimer) {
        clearTimeout(this.flipTimer);
        this.flipTimer = null;
      }

      if (this.progress === 1) {
        this.status = 'flipping';
        this.flipTimer = setTimeout(() => {
          this.status = 'full';
          this.flipTimer = null;
        }, 700);
      } else this.status = 'not-full';
    }
  }
};
